$(document).ready(function() {
    setTimeout(function() {
      if ($('.whatmore-base').length > 0 && $('.sub-collection-title').length > 0) {
        $('.whatmore-base').insertAfter('.sub-collection-title');
      }
    }, 100); 
  });



/* footer toogle */
 if ($(window).width() < 767){
       $('footer .footer-block__heading').each(function(){
          $(this).click(function(){
              $(this).siblings('.footer-block__details-content').slideToggle()
          })
       })
      }

$(window).scroll(function() {
  if ($(window).scrollTop() > 8) { 
    $('.utillity-bar-main').addClass('open');
  } else {
    $('.utillity-bar-main').removeClass('open');
  }
});


$(document).on('click', '.new-navv-a.header__icon.header__icon--cart.link.focus-inset.site-header-cart--button', function(event) {
    event.preventDefault();
    $('.drawer').addClass('active');
});

function adjustProductAccordions() {
    const accordions = document.querySelectorAll('.product__accordion details');
    accordions.forEach((accordion) => {
      const summary = accordion.querySelector('summary');
      if (!summary) return;
      if (window.innerWidth < 768) {
        accordion.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      } else {
        accordion.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }
    });
  }
  document.addEventListener('DOMContentLoaded', adjustProductAccordions);
  window.addEventListener('resize', adjustProductAccordions);


const details = document.getElementById("Details-menu-drawer-container");
const chatbot = document.getElementById("react-chatbot-container");

details.addEventListener("toggle", () => {
  if (details.open) {
    chatbot.style.display = "none";
  } else {
    chatbot.style.display = "block";
  }
});


/******************** New menu drawer js ************************/


(function () {
  function setupScrollSyncForShopBy(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    // Find the "Shop By" details block inside this container
    const shopByDetail = Array.from(container.querySelectorAll('details')).find(detail => {
      const summary = detail.querySelector('summary span.left-menu-link');
      return summary && summary.textContent.trim() === 'Shop By';
    });
    if (!shopByDetail) return;

    const scrollContainer = shopByDetail.querySelector(".third-lvl-hamburger");
    const leftMenuItems = shopByDetail.querySelectorAll(".collection-summary");
    const rightSections = Array.from(scrollContainer?.querySelectorAll(".third-lvl-group") || []);

    if (!scrollContainer || !rightSections.length || !leftMenuItems.length) return;

    const sectionMap = {};
    leftMenuItems.forEach(item => {
      const id = item.getAttribute("data-scroll-target");
      if (id) sectionMap[id] = item;
    });

    let activeId = "";

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const currentId = entry.target.getAttribute("id");
            if (currentId !== activeId && sectionMap[currentId]) {
              activeId = currentId;

              leftMenuItems.forEach(el => el.classList.remove("active-summary"));
              sectionMap[currentId].classList.add("active-summary");
            }
          }
        });
      },
      {
        root: scrollContainer,
        threshold: 0.6,
      }
    );

    rightSections.forEach(section => observer.observe(section));

    leftMenuItems.forEach(item => {
      item.addEventListener("click", () => {
        const id = item.getAttribute("data-scroll-target");
        const targetSection = shopByDetail.querySelector(`#${id}`);
        if (targetSection) {
          scrollContainer.scrollTo({
            top: targetSection.offsetTop - scrollContainer.offsetTop,
            behavior: "smooth"
          });
        }
      });
    });
  }

  function waitAndInit() {
    setupScrollSyncForShopBy("#HeaderDrawerMenu");
    // Call also for other menus if needed, e.g., StickyMobileMenu:
    setupScrollSyncForShopBy("#StickyMobileMenu");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", waitAndInit);
  } else {
    waitAndInit();
  }
})();






//Product page judge me widget hide show script

document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(() => {
        const widget = document.querySelector('.jdgm-rev-widg');
        const header = widget?.querySelector('.jdgm-rev-widg__header');
        if (!widget || !header) return;
        const selectors = [
            '.jdgm-row-actions',
            '.jdgm-rev-widg__body',
            '.jdgm-rev-widg__paginate-spinner-wrapper'
        ];
        const targets = selectors
            .map(sel => widget.querySelector(sel))
            .filter(Boolean);
        if (targets.length !== selectors.length) return;
        targets.forEach(el => {
            el.classList.add('jdgm-slide-toggle');
            el.classList.remove('active'); // make sure it's collapsed initially
        });
        header.style.cursor = 'pointer';
        header.addEventListener('click', () => {
            targets.forEach(el => {
                el.classList.toggle('active');
            });
        });
        observer.disconnect(); // done
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const checkInterval = setInterval(function () {
    const writeReviewButton = document.querySelector('.jdgm-write-rev-link');
    if (writeReviewButton) {
      const seeAllReviewsLink = document.createElement('a');
      seeAllReviewsLink.href = "#reviews"; 
      seeAllReviewsLink.textContent = "See All Reviews";
      seeAllReviewsLink.className = "see-all-reviews-link";
      seeAllReviewsLink.style.display = "block";
      seeAllReviewsLink.style.marginTop = "10px";
      seeAllReviewsLink.style.color = "#ff9900"; 
      seeAllReviewsLink.style.textDecoration = "none";
      writeReviewButton.parentElement.appendChild(seeAllReviewsLink);

      clearInterval(checkInterval);
    }
  }, 500);
});




//chatbox hide for menu drawer and cart drawer
 document.addEventListener("DOMContentLoaded", function () {
  const menuDrawer = document.getElementById('Details-menu-drawer-container');
  const cartDrawer = document.querySelector('cart-drawer');
  const chatWidget = document.getElementById('chat-widget');
  const hamburgerMenu = document.querySelector('.hamburger-coll');

  if (!chatWidget) return;

  function toggleChatWidget() {
    const isMenuOpen =
      (menuDrawer &&
        menuDrawer.classList.contains('menu-opening') &&
        menuDrawer.hasAttribute('open')) ||
      (hamburgerMenu &&
        hamburgerMenu.classList.contains('active') &&
        hamburgerMenu.style.display !== 'none');

    const isCartOpen =
      cartDrawer &&
      cartDrawer.classList.contains('active');

    chatWidget.style.display = (isMenuOpen || isCartOpen) ? 'none' : 'block';
  }

  if (menuDrawer) {
    const menuObserver = new MutationObserver(toggleChatWidget);
    menuObserver.observe(menuDrawer, {
      attributes: true,
      attributeFilter: ['class', 'open']
    });
  }

  if (cartDrawer) {
    const cartObserver = new MutationObserver(toggleChatWidget);
    cartObserver.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (hamburgerMenu) {
    const hamburgerObserver = new MutationObserver(toggleChatWidget);
    hamburgerObserver.observe(hamburgerMenu, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  toggleChatWidget();
});

/*---- collection grid video block js ----*/

document.addEventListener('DOMContentLoaded', function () {
    const videoLinks = document.querySelectorAll('.video-block-click');

    videoLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault(); // Prevent default link behavior

        // Check if Whatmore exists
        const whatmoreExists = document.querySelector('.whatmore-carousel-events');

        if (whatmoreExists) {
          // Try to find and click the Whatmore tile
          const firstSlide = whatmoreExists.querySelector('.swiper-wrapper > .swiper-slide');
          if (firstSlide) {
            const clickable = firstSlide.querySelector('.whatmore-template-b-event-tile');
            if (clickable) {
              clickable.click();
              console.log('Whatmore opened successfully.');
              return;
            }
          }

          console.warn('Whatmore tile not found.');
          // Optional: fallback redirect if Whatmore exists but tile is missing
          window.location.href = '/collections/reels';
        } else {
          // If Whatmore section is missing completely, redirect
          console.warn('Whatmore not found. Redirecting...');
          window.location.href = '/collections/reels';
        }
      });
    });
  });

